
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/worldschooling",
      function () {
        return require("private-next-pages/worldschooling/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/worldschooling"])
      });
    }
  